/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, SidebarLayout } from '@scuf/common';
import { AppContext, NotificationHeader } from '@keystone/common';
import { withRouter } from 'react-router-dom';
import Routes from '../common/routes';
import RuleMenu from './RuleMenu';
import APIClient, { isValidUserforRules } from '../common/APIClient';

const { Sidebar } = SidebarLayout;

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      voiceArtisanMenuOpen: false,
      slaMenuOpen: false,
      devKitMenuOpen: false,
      permissions: [],
      isAdmin: false,
    };
  }

  componentDidMount() {
    // console.log(this.props);
    this.isUserAdmin();
    // this.fetchUserPermissions();
  }

  // fetchUserPermissions = async () => {
  //   const { user } = this.context;
  //   const permissions = await APIClient.getUserPermissions(user);
  //   this.setState({ permissions });
  // };

  isUserAdmin = async () => {
    const { user, handleError } = this.context;
    if (user) {
      const userValidForRules = isValidUserforRules(user.email);
      try {
        let adminUsersList = await APIClient.fetchConfiguration(user);
        adminUsersList = adminUsersList.response;
        let isAdmin = false;
        if (
          userValidForRules ||
          (adminUsersList.emails !== undefined &&
            adminUsersList.emails.length > 0 &&
            adminUsersList.emails.includes(user.email))
        ) {
          isAdmin = true;
        }
        this.setState({ isAdmin });
      } catch (err) {
        console.error(err);
        handleError(err);
      }
    }
  };

  renderTaskConversionToolMenu() {
    const { location } = this.props;
    const { devKitMenuOpen } = this.state;
    return (
      <Sidebar.Submenu
        content="Convert Task File to DevKit Project"
        open={devKitMenuOpen}
        onClick={() => {
          this.setState({ devKitMenuOpen: !devKitMenuOpen });
        }}
        icon={<Icon root="common" name="document-deploy-client" />}
      >
        <Sidebar.Item
          content="Upload Task File"
          onClick={() => {
            this.props.history.push(Routes.Task);
          }}
          active={location.pathname === Routes.Task}
          icon={<Icon root="common" name="cloud-upload" />}
        />
        <Sidebar.Item
          content="Upload History"
          onClick={() => {
            this.props.history.push(Routes.TaskHistory);
          }}
          active={location.pathname === Routes.TaskHistory}
          icon={<Icon root="common" name="document-history" />}
        />
      </Sidebar.Submenu>
    );
  }

  renderVACTMenu() {
    const { location } = this.props;
    const { voiceArtisanMenuOpen, isAdmin } = this.state;
    const { user } = this.context;
    return (
      <Sidebar.Submenu
        content="Voice Application Compatibility Tool"
        open={voiceArtisanMenuOpen}
        onClick={() => {
          this.setState({ voiceArtisanMenuOpen: !voiceArtisanMenuOpen });
        }}
        icon={<Icon root="common" name="document-publish" />}
      >
        <Sidebar.Item
          content="Scan VAD"
          onClick={() => {
            this.props.history.push(Routes.Vad);
          }}
          active={location.pathname === Routes.Vad}
          icon={<Icon root="common" name="cloud-upload" />}
        />
        {user != null && isAdmin ? (
          <RuleMenu />
        ) : (
          <Sidebar.Item
            content="Rule"
            onClick={() => {
              this.props.history.push(Routes.Rules);
            }}
            active={location.pathname === Routes.Rules}
            icon={<Icon root="common" name="adjustments" />}
          />
        )}
        {user != null && isAdmin ? (
          <Sidebar.Item
            content="History"
            onClick={() => {
              this.props.history.push(Routes.History);
            }}
            active={location.pathname === Routes.History}
            icon={<Icon root="common" name="document-history" />}
          />
        ) : (
          ''
        )}
      </Sidebar.Submenu>
    );
  }

  renderSLAMenu() {
    const { location } = this.props;
    const { slaMenuOpen, isAdmin } = this.state;
    const { user } = this.context;
    if (user != null && isAdmin) {
      return (
        <Sidebar.Submenu
          content="SLA Management"
          open={slaMenuOpen}
          onClick={() => {
            this.setState({ slaMenuOpen: !slaMenuOpen });
          }}
          icon={<Icon root="common" name="document-certification" />}
        >
          <Sidebar.Item
            content="SLA Status"
            onClick={() => {
              this.props.history.push(Routes.SLATable);
            }}
            active={location.pathname === Routes.SLATable}
            icon={<Icon root="common" name="table" />}
          />
          <Sidebar.Item
            content="Create New SLA"
            onClick={() => {
              this.props.history.push(Routes.CreateSLA);
            }}
            active={location.pathname === Routes.CreateSLA}
            icon={<Icon root="common" name="slidercontrols-plus" />}
          />
        </Sidebar.Submenu>
      );
    }
    return <></>;
  }

  render() {
    const { children, location } = this.props;
    const { isAdmin } = this.state;
    const { user, notification, isSidebarCollapsed } = this.context;
    return (
      <SidebarLayout className="app-sidebar" collapsed={isSidebarCollapsed}>
        <Sidebar>
          <Sidebar.Item
            content="Home"
            onClick={() => {
              this.props.history.push(Routes.Home);
            }}
            active={location.pathname === Routes.Home}
            icon={<Icon root="common" name="home" />}
          />
          {this.renderTaskConversionToolMenu()}
          {this.renderVACTMenu()}
          {this.renderSLAMenu()}
          {user != null && isAdmin ? (
            <Sidebar.Item
              content="Configuration"
              onClick={() => {
                this.props.history.push(Routes.ViewConfiguration);
              }}
              active={location.pathname === Routes.ViewConfiguration}
              icon={<Icon root="common" name="settings" />}
            />
          ) : (
            ''
          )}
        </Sidebar>
        <SidebarLayout.Content>
          {notification.hasNotification ? <NotificationHeader /> : <></>}
          {children}
        </SidebarLayout.Content>
      </SidebarLayout>
    );
  }
}

Nav.contextType = AppContext;

Nav.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default withRouter(Nav);
